module.exports = __webpack_public_path__ + "static/media/file-activity-tracker-logo.d149f676.png";